import { render, staticRenderFns } from "./viewcommission.vue?vue&type=template&id=4e313cf2"
import script from "./viewcommission.vue?vue&type=script&lang=js"
export * from "./viewcommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports